export default __webpack_public_path__ + "static/media/help-videogon@3x.20d3bd70.png";